import { Button, Card, DatePicker, Form, Input, Modal, Popconfirm, Select, Upload, notification } from 'antd'
import { useEffect, useState } from 'react'
import dayjs from 'dayjs';
import { Viewer, Worker } from "@react-pdf-viewer/core";

// Plugins
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";

// Import styles
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

import { PaperClipOutlined, DeleteTwoTone, InboxOutlined } from '@ant-design/icons'
import { recordError } from "../../utils/logService";
import service from '../../services/documentRepoService'
import apiLookups from "../../services/commonLookupService";

import {ActivityIndicator,
  FormItemList,
  Messages,
  Notify,
  openNotification,
  pdfjsVersion,
  util
} from '@seims/shared';

export default function DocumentDetails(props) {

  const selectWidth = "50%";
  const initWidth = 900;
  const initFileLabel = "Document File";
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  const [types, setTypes] = useState([]);
  const [categories, setCategories] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const [uploadedFile, setUploadedFile] = useState();
  const [loading, setLoading] = useState(true);
  const [physicalFile, setPhysicalFile] = useState({});
  const [toggleView, setToggleView] = useState();
  const [docTitle, setDocTitle] = useState();
  const [docData, setDocData] = useState({});
  const [canUploadFile, setCanUploadFile] = useState(false);
  const [fileRequired, setFileRequired] = useState(props.type === "add/Upload")

  const [languages, setLanguages] = useState([]);
  var [affiliatedOrganisations, setAffiliatedOrganisations] = useState([]);
  var [fundingAgencies, setFundingAgencies] = useState([]);
  var [documentCategories, setDocumentCategories] = useState([]);
  const [modalWidth, setModalWidth] = useState(initWidth);
  const [fileLabel, setFileLabel] = useState(initFileLabel);

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("http://localhost");
  const [previewTitle, setPreviewTitle] = useState("");
  const [toggleFiles, setToggleFiles] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [progressMessage, setProgressMessage] = useState("");

  // const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const { TextArea } = Input;
  const [form] = Form.useForm();
  const { Option } = Select;
  const formName = "DocumentDetails";
  const allowedFileSize = ((process.env.NODE_ENV === "development")
    ? process.env.REACT_DOCREPO_UPLOAD_LIMIT
    : window._CONFIGS.REACT_DOCREPO_UPLOAD_LIMIT) || 52428800;
  const fSize = allowedFileSize / 1024 / 1024;

  let msg = "";
  let heading = "";
  const { Dragger } = Upload;

  useEffect(() => {
    toggleModalTitles();

    if (props.hasUpdated) {
      getDropdownOptions();
    }
    setCanUploadFile(props.type !== "view" && props.type !== "ratify");
    setFileRequired(props.type === "add/Upload");
    setFileLabel((props.type !== "view" && props.type !== "ratify") ? initFileLabel : "Uploaded File");
    if (props.record?.id) {
      getDocumentById(props.record?.id);
    }

    window.addEventListener('resize', () => {
      const screenWidth = window.innerWidth;
      if (screenWidth < initWidth) {
        setModalWidth(screenWidth * 0.8);
      }
    })
  }, [props.record, window]);

  const toggleModalTitles = () => {
    var _title = props.type?.charAt(0).toUpperCase() + props.type?.slice(1);
    setDocTitle(_title + " Document");
  };

  const toggleProgressMessage = (target, action) => {
    const _fMsg = `${target} is being ${action}, please wait...`
    setProgressMessage(_fMsg);
  }

  const getDropdownOptions = async () => {
    getDocumentTypes();
    getDocumentCategories();
    getAffiliatedOrganisations();
    getFundingAgencies();
    getLanguages();
    props.setHasUpdated(false);
  };

  const sortValues = (data, label = '') => {
    const sortedValues = data.sort((a, b) => a.value.localeCompare(b.value));
    return sortedValues;
  };

  const transformToKeyValues = (data, label = '') => {
    const _keyValues = data.flatMap((item) =>
      (item.active === true || item.active === undefined) ?
        { key: item.id, value: item.name !== undefined ? item.name : item.description } : []
    );

    return sortValues(_keyValues, label);
  }

  const filterActiveValues = (data, label = '') => {
    const _keyValues = data.flatMap((item) =>
      (item.active === true || item.active === undefined) ? { ...item } : []
    );

    return sortValues(_keyValues, label);
  }

  const getDocumentById = async (documentId) => {
    try {
      const response = await service.getDocumentById(documentId);
      if (response && response.status === 200) {
        const { data } = response;
        setDocData(data);
        onFormLoad(data);
      } else {
        setDocData({});
      }

    } catch (error) {
      recordError(error);
    }
  };

  const getLanguages = async () => {
    try {
      const response = await apiLookups.getLanguges();
      if (response && response.status === 200) {
        const { data } = response;
        const sorted = filterActiveValues(data, "language");
        setLanguages(sorted);
      } else {
        setLanguages([]);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getDocumentTypes = async () => {
    try {
      const response = await service.getDocumentTypes();
      if (response && response.status === 200) {
        const { data } = response;
        const sortedkeyValues = filterActiveValues(data, "Type");
        setTypes(sortedkeyValues);
      } else {
        setTypes([]);
      }
    } catch (error) {
      console.error(error);
      recordError(error);
    }
  };

  const getDocumentCategories = async () => {
    try {
      const response = await service.getDocumentCategories();
      if (response && response.status === 200) {
        const { data } = response;
        const sortedkeyValues = filterActiveValues(data, "Category");
        setCategories(sortedkeyValues);
      } else {
        setCategories([]);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getAffiliatedOrganisations = async () => {
    try {
      const response = await service.getAffiliatedOrganisations();
      if (response && response.status === 200) {
        const { data } = response;
        const sortedkeyValues = filterActiveValues(data, "Affiliated");
        setAffiliatedOrganisations(sortedkeyValues);
      } else {
        setAffiliatedOrganisations([]);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getFundingAgencies = async () => {
    try {
      const response = await service.getFundingAgencies();
      if (response && response.status === 200) {
        const { data } = response;
        const sortedkeyValues = filterActiveValues(data, "Funding");
        setFundingAgencies(sortedkeyValues);
      } else {
        setFundingAgencies([]);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const previewDocument = async (id, filename) => {
    try {
      toggleProgressMessage("File", "downloaded");
      setSubmitted(true);
      const response = await service.downloadFile(id);
      if (response && response.status === 200) {
        setSubmitted(false);
        const { data } = response;
        const new_blob = new Blob([data]);
        const url = URL.createObjectURL(new_blob);

        setPreviewImage(url);
        setPreviewOpen(true);
        setPreviewTitle("Preview: " + filename);
        // setToggleFiles(record.type != "application/pdf");
        // URL.revokeObjectURL(url);
      }

    } catch (error) {
      recordError(error);
    }
  };

  const handleFileDownload = async (id, filename) => {
    try {
      toggleProgressMessage("File", "downloaded");
      setSubmitted(true);
      const response = await service.downloadFile(id);
      if (response && response.status === 200) {
        setSubmitted(false);
        const { data } = response;
        setPhysicalFile(data);
        const new_blob = new Blob([data]);
        const url = URL.createObjectURL(new_blob);
        const downloadLink = document.createElement("a");

        downloadLink.href = url;
        downloadLink.download = filename;
        downloadLink.click();
        URL.revokeObjectURL(url);
      }
    } catch (error) {
      msg = util.parseMessage(Messages.FILEDOWNLOAD_FAILURE, "File");
      openNotification("File Download", msg, Notify.ERROR);
      console.log("PHYSICAL FILE", error);
      recordError(error);
    }
  };

  const confirmCancel = () => {
    setSubmitted(false);
    form.resetFields();
    props.onShow(false);
    setDisabled(true);
    setUploadedFile(null);
    setDocData({});
  };

  const handleCancel = () => {
    if (
      form.getFieldValue("title") ||
      form.getFieldValue("description") ||
      form.getFieldValue("authors") ||
      form.getFieldValue("documentType") ||
      form.getFieldValue("documentCategory") ||
      form.getFieldValue("approvalDate") ||
      form.getFieldValue("affiliatedOrganisations") ||
      form.getFieldValue("keywords") ||
      form.getFieldValue("language") ||
      form.getFieldValue("fundingAgency") ||
      form.getFieldValue("fileDetails") ||
      (uploadedFile !== null && uploadedFile?.length > 0)
    ) {
      setDisabled(false);
    } else {
      confirmCancel();
    }
  };

  const handleUpload = (file) => {
    const allowedFileTypes = ['application/pdf'];

    if (!allowedFileTypes.includes(file.type)) {
      openNotification("File Validation", `${file.name} is not a valid file type`, Notify.ERROR);
      return Upload.LIST_IGNORE;
    }

    notification.destroy("seims");

    if (file.size > allowedFileSize) {
      openNotification("File Size", `File must be smaller than ${fSize}MB`, Notify.WARNING);

      return Upload.LIST_IGNORE;
    }
    setUploadedFile(file);
    return false;
  };

  const uploadInfo = {
    accept: ".pdf",
    multiple: false,
    showUploadList: false,
    beforeUpload: handleUpload,
    onRemove() {
      setUploadedFile(null);
    },
  };

  const mapKeyValues = (dataList, lookupList) => {
    const keys = dataList?.map((org) => {
      return lookupList.find((record) => record.value == org)?.key || org;
    });

    return keys;
  };

  const onFormLoad = (data) => {

    if (!util.isEmpty(data)) {

      var authorObj = data.authors?.toString().replaceAll(',', ', ');
      var keywordsObj = data.keywords?.toString().replaceAll(',', ', ');
      const documentType = types.find((record) => record.value === data.pubType)?.key || data.pubType;
      const documentCategory = categories.find((record) => record.value === data.category)?.key || data.category;
      const affiliateIDs = affiliatedOrganisations.map((o) => o.key);
      const affiliates = data.organisations.map((o) =>
        affiliateIDs.includes(o.organizationId) ? o.organizationId : o.name);
      const agencyIDs = fundingAgencies.map((f) => f.key);
      const agencies = data.fundinAgencies.map((f) =>
        agencyIDs.includes(f.organizationId) ? f.organizationId : f.name);
      const lans = data.languages.map((lang) => lang.key);

      const approvalDate = (data.approvalDate !== undefined && data.approvalDate !== null
        && data.approvalDate !== "0001-01-01T00:00:00" && data.approvalDate != "No-Date") ?
        dayjs(data.approvalDate, 'YYYY-MM-DD HH:mm:ss') : "";

      form.setFieldsValue({

        id: data.id,
        title: data.title,
        description: data.description,
        authors: (props.type !== "view") ? data.authors : authorObj,
        documentType: documentType,
        documentCategory: documentCategory,
        approvalDate: approvalDate,
        affiliatedOrganisations: affiliates,
        keywords: (props.type !== "view") ? data.keywords : keywordsObj,
        language: lans,
        fundingAgency: agencies,
        fileDetails: data.filename
      });
    }
  };

  const submitDocument = async (values) => {

    const noFile = (uploadedFile === undefined || uploadedFile === null || uploadedFile.length === 0);
    if (noFile && props.type === "add/Upload") {
      msg = util.parseMessage(Messages.FILE_UPLOAD_NO_FILE, "Documents");
      openNotification("File upload Failed", msg, Notify.ERROR);
      return;
    }
    const action = (props.type === "ratify") ? "ratified" : "uploaded";
    toggleProgressMessage("Document", action);

    var formData = null;
    var response = null;
    try {
      setSubmitted(true);
      if (props.type === "ratify") {
        formData = {

          "id": values.id,
          "title": values.title,
          "description": values.description,
          "typeId": values.documentType,
          "categoryId": values.documentCategory,

          "affiliatedOrganisations": values.affiliatedOrganisations,
          "fundingAgencies": values.fundingAgency,
          "keywords": values.keywords,
          "authors": values.authors,
          "languages": values.language,
        }
        if (values.approvalDate !== undefined && values.approvalDate !== null
          && values.approvalDate != "") {
          formData.approvalDate = values.approvalDate?.format('YYYY-MM-DD');
        }
      } else {
        formData = new FormData();
        formData.append("id", values.id);
        formData.append("title", values.title);
        formData.append("description", values.description);
        formData.append("typeId", values.documentType);
        formData.append("categoryId", values.documentCategory);
        if (values.approvalDate !== undefined && values.approvalDate !== null
          && values.approvalDate != "") {
          formData.append("approvalDate", values.approvalDate?.format('YYYY-MM-DD'));
        }
        formData.append("uploadedFile", uploadedFile);

        addArrayToForm(formData, "affiliatedOrganisations", values.affiliatedOrganisations);
        addArrayToForm(formData, "fundingAgencies", values.fundingAgency);
        addArrayToForm(formData, "keywords", values.keywords);
        addArrayToForm(formData, "authors", values.authors);
        addArrayToForm(formData, "languages", values.language);


      }
  

      switch (props.type) {

        case "edit":
          heading = "Document Updating"
          msg = "Document updated successfully"
          response = await service.updateDocument(formData)
          break;

        case "ratify":
          heading = "Document Ratification"
          msg = "Document ratified successfully"
          response = await service.ratifyDocument(formData)
          break;

        case "add/Upload":
        default:
          heading = "Document Saving"
          msg = "Document saved successfully"
          response = await service.uploadDocument(formData)
          break;
      }

      // const request = props.type !== "edit" ? await service.uploadDocument(formData)
      //   : await service.updateDocument(formData);

      if (response.status === 200 || response.status === 201) {
        openNotification(heading, msg, Notify.SUCCESS);

        confirmCancel();
        props.setHasUpdated(!props.hasUpdated);
        return;
      }

      msg = util.parseMessage(Messages.FILEUPLOAD_FAILURE, "Documents");
      openNotification("File upload Failed", msg, Notify.ERROR);
    } catch (error) {
      msg = (error.response.status == 403) ? "You are not allowed to ratify own documents"
        : `Attempt to ${props.type} the document failed`;
      openNotification(heading, msg, Notify.ERROR);
      recordError(error);
    }
    setSubmitted(false);
  };

  const addArrayToForm = (_form, _element, arrayaData) => {
    arrayaData.forEach((item) => {
      _form.append(_element, item);
    })
  }

  const cancel = () => {
    // var msg = util.parseMessage(Messages.UPDATE_CANCELLED);
    // openNotification("Action cancelled successfully", msg, Notify.INFO);
  };

  const handlePreviewCancel = () => {
    setPreviewOpen(false);
  }

  const handleSelectFilter = (input, option) => {
    return (option?.label?.toLowerCase() ?? '').includes(input.toLowerCase());
  }

  return (
    <>
      <Modal
        className='doc-repo'
        key={"dd-main-modal"}
        // forceRender
        title={docTitle}
        open={props.record}
        closable={false}
        keyboard={false}
        maskClosable={false}
        width={modalWidth}
        // bodyStyle={{
        //   height: "90vh",
        // }}
        footer={[
          <div className="modal-footer-buttons" key={"main-div-dd"}>
            {props.type === "view" && (
              <Button
                onClick={() => confirmCancel()}
                style={{ marginLeft: 10 }}
              >
                Okay
              </Button>
            )}
            {props.type === "ratify" && (
              <>
                <Popconfirm
                  title="Are you sure you want to delete this record?"
                  onConfirm={() => props.onShow(props.record, "delete")}
                  onCancel={() => cancel()}
                  okText="Yes"
                >
                  <Button
                    style={{ marginLeft: 10 }}
                  >
                    Delete
                  </Button>
                </Popconfirm>
                <Button
                  disabled={submitted}
                  key="dd-btn-1"
                  type="primary"
                  htmlType="submit"
                  form={formName}
                  style={{ marginLeft: 10 }}
                >
                  Ratify
                </Button>
              </>
            )}
            {canUploadFile && (
              <Button
                disabled={submitted}
                key="dd-btn-2"
                type="primary"
                htmlType="submit"
                form={formName}
                style={{ marginLeft: 10 }}
              >
                Save
              </Button>
            )}
            <Popconfirm
              key="dd-pop-1"
              title="Are you sure you want to cancel...you will lose all info entered?"
              okText="Yes"
              cancelText="No"
              onConfirm={() => confirmCancel()}
              onCancel={() => handleCancel()}
              disabled={disabled}
            >
              {props.type !== "view" && (
                <Button
                  onMouseUp={() => handleCancel()}
                  style={{ marginLeft: 10 }}
                >
                  Cancel
                </Button>
              )}

            </Popconfirm>
          </div>,
        ]}
      >
        <Form
          key={"dd-main-form"}
          disabled={props.type === "view"}
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 18,
          }}
          className='doc-repo'
          form={form}
          name={formName}
          onFinish={submitDocument}
        >
          <Card>
            <Form.Item
              hidden={true}
              name="id"
              label="id"
            >
              <Input name="id" />
            </Form.Item>
            <Form.Item
              name="title"
              label="Title"
              rules={[
                {
                  required: true,
                  message: "Please provide document title",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="description"
              label="Description"
              rules={[
                {
                  required: true,
                  message: "Please provide title description",
                },
              ]}
            >
              <TextArea rows={3} />
            </Form.Item>
            {props.type === "view" && (
              <Form.Item
                name="authors"
                label="Author(s)"
                required={true}
              >
                <Input name="authors" />
              </Form.Item>
            )}
            {props.type !== "view" && (
              // <AuthorField />
              <Form.Item
                name="authors"
                label="Author(s)"
                rules={[
                  {
                    required: true,
                    message: "Please provide authors of the document",
                  },
                ]}
              >
                <FormItemList name={"authors"} buttonLabel={"Add Author"} placeholder="Author's Full Name" />
              </Form.Item>
            )}
            <Form.Item
              name="documentType"
              label="Document Type"
              rules={[
                {
                  required: true,
                  message: "Please select document type",
                },
              ]}
            >
              <Select
                placeholder="Select document type"
                allowClear
                style={{
                  width: selectWidth,
                }}
                showSearch
                filterOption={handleSelectFilter}
                options={types.map((type) => ({
                  key: type.value + type.key,
                  value: type.key,
                  label: type.value,
                }))}
              />
            </Form.Item>
            <Form.Item
              name="documentCategory"
              label="Document Category"
              rules={[
                {
                  required: true,
                  message: "Please select document category",
                },
              ]}
            >
              <Select
                placeholder="Select document category"
                allowClear
                style={{
                  width: selectWidth,
                }}
                showSearch
                filterOption={handleSelectFilter}
                options={categories.map((category) => ({
                  key: category.value + category.key,
                  value: category.key,
                  label: category.value,
                }))}
              />
            </Form.Item>
            <Form.Item
              name="approvalDate"
              label="Approval Date"
              rules={[
                {
                  required: false,
                  message: "Please select a date",
                },
              ]}
            >
              <DatePicker
                // Disable future dates on the picker
                disabledDate={(current) => {
                  return (current && (current.valueOf() >= dayjs(Date.now())));
                }}
              />
            </Form.Item>
            <Form.Item
              name="affiliatedOrganisations"
              label="Affiliated Organisation(s)"
              rules={[
                {
                  required: true,
                  message: "Please provide affiliated organisation",
                },
              ]}
            >
              <Select
                placeholder="Select affiliated organisation"
                allowClear
                mode="multiple"
                style={{
                  width: selectWidth,
                }}
                showSearch
                filterOption={handleSelectFilter}
                options={affiliatedOrganisations.map((org) => ({
                  key: org.value + org.key,
                  value: org.key,
                  label: org.value,
                }))}
              />
            </Form.Item>
            {props.type === "view" && (
              <Form.Item
                name="keywords"
                label="Keywords"
                required={true}
              >
                <Input name="keywords" />
              </Form.Item>
            )}
            {props.type !== "view" && (
              <Form.Item
                name="keywords"
                label="Keyword(s)"
                rules={[
                  {
                    required: true,
                    message: "Please provide keywords"
                  },
                ]}
              >
                <FormItemList name={"keywords"} buttonLabel={"Add Keyword"} placeholder="Keyword" disabled={false} />
              </Form.Item>
            )}
            <Form.Item
              name="language"
              label="Language(s)"
              rules={[
                {
                  required: true,
                  message: "Please select languages used in this document"
                },
              ]}
            >
              <Select
                placeholder="Select languages used in this document"
                mode="multiple"
                allowClear
                style={{
                  width: selectWidth,
                }}
                showSearch
                filterOption={handleSelectFilter}
                options={languages.map((lang) => ({
                  key: lang.value + lang.key,
                  value: lang.key,
                  label: lang.value,
                }))}
              />
            </Form.Item>
            <Form.Item
              name="fundingAgency"
              label="Funding Source(s)"
              rules={[
                {
                  required: true,
                  message: "Please select funding agency"
                },
              ]}
            >
              <Select
                placeholder="Select funding agency"
                allowClear
                mode="multiple"
                style={{
                  width: selectWidth,
                }}
                showSearch
                filterOption={handleSelectFilter}
                options={fundingAgencies.map((agency) => ({
                  key: agency.value + agency.key,
                  value: agency.key,
                  label: agency.value,
                }))}
              />
            </Form.Item>
            {canUploadFile && (
              <div style={{ alignContent: 'left', marginLeft: "160px", color: "blue" }}><b>Max file size allowed : {fSize}MB and accepted file type : PDF</b></div>
            )}
            <Form.Item
              label={fileLabel}
              required={fileRequired}
              rules={[
                {
                  required: fileRequired,
                  message: "Please select pdf document to upload",
                },
              ]}
            >
              {canUploadFile && (
                <>
                  <Dragger
                    defaultFileList={[]}
                    key={"up"}
                    maxCount={1}
                    multiple={false}
                    {...uploadInfo}

                  >
                    <p className="ant-upload-drag-icon">
                      <InboxOutlined />
                    </p>
                    Click or drag file to this area to upload
                  </Dragger>
                  <br />
                  {uploadedFile?.name && (
                    <>
                      <span ><PaperClipOutlined /> Selected file: &nbsp; {uploadedFile?.name}</span>
                      <span style={{ float: 'right' }} onClick={() => setUploadedFile(null)}><DeleteTwoTone style={{ color: 'red!important' }} />&nbsp; </span>
                      <br />
                    </>
                  )}
                </>
              )}
              {(docData?.id && docData?.filename) && (
                <>
                  {(props.type !== "view" && props.type !== "ratify") && (
                    <> &nbsp;Uploaded File: &nbsp;</>
                  )}
                  {/* <a key={docData.id} onClick={previewDocument(docData)}>{<EyeFilled style={{ fontSize: '200%', color: '#3498DB' }} />}&nbsp;&nbsp;&nbsp;</a> */}
                  <a key={docData?.filename} onClick={() => previewDocument(docData?.id, docData?.filename)}>{docData?.filename}</a>
                </>
              )}

            </Form.Item>
            {(submitted === true) && (
              <>
                <hr />
                <ActivityIndicator visible={true} message={progressMessage} />
              </>
            )}
          </Card>
        </Form>
        {previewOpen && (
          <Modal
            key={"doc-modal-preview"}
            open={previewOpen}
            title={previewTitle}
            footer={null}
            onCancel={handlePreviewCancel}
            onOk={handlePreviewCancel}
            width={modalWidth}
            maskClosable={false}
            bodyStyle={{
              height: "80vh",
            }}
          >
            <Worker
              workerUrl={`https://unpkg.com/pdfjs-dist@${pdfjsVersion()}/build/pdf.worker.min.js`}
            >
              <Viewer
                fileUrl={previewImage}
                plugins={[defaultLayoutPluginInstance]}
                renderError={console.log}
              />
            </Worker>
          </Modal>
        )}
      </Modal>
    </>
  )
}
